/**
 * Rounds the given value to the specified decimalPlaces
 *
 * <i>Source http://www.jacklmoore.com/notes/rounding-in-javascript/<i>
 *
 * @param value {number}
 * @param decimalPlaces {number}
 * @returns {number}
 */
export function round(value, decimalPlaces) {
  return Number(`${Math.round(Number(`${value}e${decimalPlaces}`))}e-${decimalPlaces}`);
}

/**
 * Returns a pretty string representation of a date relative to the current date.
 *
 * @param date {Date}
 * @returns {string}
 */
export function prettyDate(date) {
  date = new Date(date);
  const currentDate = new Date();
  const truncDate = new Date(date);
  [currentDate, truncDate].forEach(d => d.setHours(0, 0, 0, 0));
  return date.toLocaleString(navigator.language, {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}); // WEB-43147
}

export function formatDateString(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function formatTime12Hour(dateString) {
  const date = new Date(dateString);
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // Convertir a formato de 12 horas
  return `${hours}:${minutes} ${ampm}`;
}
/**
 * Returns a pretty string representation of a memory size.
 *
 * @param size {number}
 * @returns {string}
 */
export function prettySize(size, decimalPlaces = 2) {
  const divisor = 1024;
  if (size < Math.pow(divisor, 2)) {
    return `${round(size / divisor, decimalPlaces)} KiB`;
  } else if (size < Math.pow(divisor, 3)) {
    return `${round(size / Math.pow(divisor, 2), decimalPlaces)} MiB`;
  }
  return `${round(size / Math.pow(divisor, 3), decimalPlaces)} GiB`;
}

